import { initDossiersCarousel } from '../carousel/carousel.js';
import { manageButton } from '../selection/utils.js';
import { avoidUpscalingImage, checkImageInError } from '../utils/utils.js';

export const init = () => {
  initDossiersCarousel(document.querySelector('.illustration .carousel'));

  const selectionButton = document.querySelector(
    '.search-results-preview [data-action="selection:add"]',
  );
  if (selectionButton) {
    manageButton(selectionButton);
  }

  const imageElement = document.querySelector('.illustration-plein-ecran img');
  if (imageElement) {
    avoidUpscalingImage(imageElement);

    checkImageInError(imageElement, '.image-container');
  }
};
